module.exports = __webpack_public_path__ + "assets/img/star_sentence_un3.2967add0.png";